import {Banner, CalloutIcon} from '@wandb/components';
import React from 'react';

type MultiMetricPanelsEmptyStateProps = {
  isRegexEmpty: boolean;
  isRegexFieldInvalid: boolean;
};

export const MultiMetricPanelsEmptyState = ({
  isRegexEmpty,
  isRegexFieldInvalid,
}: MultiMetricPanelsEmptyStateProps) => {
  if (isRegexFieldInvalid) {
    return null;
  }

  if (isRegexEmpty) {
    return <HelpTextWithExamples />;
  }

  return (
    <Banner variant="info" isDismissible={false}>
      No metrics matched. Please try a different regex.
    </Banner>
  );
};

const HelpTextWithExamples = () => {
  return (
    <div className="flex flex-col gap-16 items-center m-20">
      <CalloutIcon icon="lightbulb-info" color="blue" />
      <div className="text-center mx-16">
        <p className="text-lg font-semibold">
          Plot efficiently with capture groups
        </p>
        <p className="text-sm">
          Use capture groups to create multiple plots at the same depth of the
          metric hierarchy.
        </p>
      </div>
      <div className="grid grid-cols-[auto_1fr] gap-x-12">
        {EXAMPLES.map(example => (
          <div
            key={example.regex}
            className="grid col-span-2 grid-cols-[subgrid] py-12 border-t border-solid border-wb-border items-center">
            <div className="text-sm font-[Inconsolata] bg-[light-dark(var(--moon-100),var(--moon-800))] rounded h-fit px-16 py-8 text-center">
              {example.regex}
            </div>
            <p className="text-sm">{example.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
const EXAMPLES = [
  {
    regex: 'train/(layer.+)/.+',
    description:
      'Create a plot for each layer in train, each containing every metric for that layer.',
  },
  {
    regex: '(train|val)/layer1/.+',
    description:
      'Create distinct plots for train and val, each containing every metric for layer1.',
  },
  {
    regex: '.+/layer.+/(.+)',
    description:
      'Create a plot for every tail metric, containing all variants of that metric across all sections and layers.',
  },
];
